export const Constants = {
  TAG_NAME: 'pop-sector-diversification-chart-component',
  X_AXIS_LABEL: 'Year',
  Y_AXIS_LABEL: '% of portfolio',
} as const;
